import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export function SortableRow({ id, children, className, onClick, isOverlay }: { id: string, children: React.ReactNode, className?: string, onClick?: (e: React.MouseEvent) => void, isOverlay?: boolean }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = transform && !isOverlay ? {
    transform: CSS.Transform.toString(transform),
    transition,
  } : undefined;

  // We wrap the children in a component that gives us a drag handle
  return (
    <tr ref={!isOverlay ? setNodeRef : undefined} style={style} onClick={onClick} className={`${className || ''} ${isDragging && !isOverlay ? 'opacity-30 outline-dashed outline-2 outline-zinc-600 outline-offset-[-2px] bg-zinc-800/20' : ''} ${isOverlay ? 'bg-zinc-800 shadow-[0_20px_50px_rgba(0,0,0,0.5)] outline outline-2 outline-emerald-500 relative z-50 !transition-none scale-[1.01] opacity-95' : ''}`}>
      <td className="px-2 py-4 w-8 text-center cursor-move text-zinc-400 hover:text-zinc-400 touch-none select-none" aria-label="Reorder row" {...attributes} {...listeners} onClick={(e) => e.stopPropagation()}>
        <GripVertical size={14} className="mx-auto pointer-events-none" />
      </td>
      {children}
    </tr>
  );
}

export function SortableMobileRow({ id, children, className, onClick }: { id: string, children: React.ReactNode, className?: string, onClick?: (e: React.MouseEvent) => void }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = transform ? {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 50 : undefined,
    position: isDragging ? 'relative' as const : undefined,
  } : undefined;

  return (
    <div ref={setNodeRef} style={style} onClick={onClick} className={`${className || ''} ${isDragging ? 'bg-zinc-800/80 shadow-2xl ring-1 ring-zinc-700 !transition-none relative z-50' : ''}`}>
      <div className="flex">
        <div className="w-12 flex items-center justify-center cursor-move text-zinc-400 hover:text-zinc-400 touch-none select-none" aria-label="Reorder row" {...attributes} {...listeners} onClick={(e) => e.stopPropagation()}>
          <GripVertical size={16} className="pointer-events-none" />
        </div>
        <div className="flex-1">
          {children}
        </div>
      </div>
    </div>
  );
}

